import { FC } from 'react';
// component
import AddIngredientComponent from 'components/main/Ingredients/Add';

const AddIngredient: FC = () => <AddIngredientComponent />;

export default AddIngredient;
